__turbopack_context__.v({
  "bigParentCell": "bondscreenerTables-module-scss-module__9ROFmW__bigParentCell",
  "dealLinkCell": "bondscreenerTables-module-scss-module__9ROFmW__dealLinkCell",
  "emptyMessage": "bondscreenerTables-module-scss-module__9ROFmW__emptyMessage",
  "externalDealLink": "bondscreenerTables-module-scss-module__9ROFmW__externalDealLink",
  "issuePriceCell": "bondscreenerTables-module-scss-module__9ROFmW__issuePriceCell",
  "noScroll": "bondscreenerTables-module-scss-module__9ROFmW__noScroll",
  "parentCell": "bondscreenerTables-module-scss-module__9ROFmW__parentCell",
  "parentContent": "bondscreenerTables-module-scss-module__9ROFmW__parentContent",
  "row": "bondscreenerTables-module-scss-module__9ROFmW__row",
  "sectorLabel": "bondscreenerTables-module-scss-module__9ROFmW__sectorLabel",
  "sizeTooltipName": "bondscreenerTables-module-scss-module__9ROFmW__sizeTooltipName",
  "sizeTooltipRow": "bondscreenerTables-module-scss-module__9ROFmW__sizeTooltipRow",
  "tableContainer": "bondscreenerTables-module-scss-module__9ROFmW__tableContainer",
});
